import axios from "../axiosInstance";

/**
 * Delete (soft delete) a membership SKU
 */
export const deleteMembershipSku = async (uuid: string): Promise<void> => {
  await axios.delete(`/api/private/membership-skus/${uuid}`);
};
